<template>
    <div class="dashboard-container">
        <!-- Grid 1: 공지사항, 이용가이드 (1x2) -->
        <div class="grid-1">
            <base-card class="grid-1-card">
                <div class="card-header">
                    <h2 class="card-title">공지사항</h2>
                    <button class="add-button" @click="goToPage('/notice/post')">+</button>
                </div>
                <div class="divider"></div>
                <ul class="card-items">
                    <li v-for="item in notice" :key="item.id" class="tab-item">
                        <div class="tab-base">
                            <p class="item-title">{{ item.title }}</p>
                            <div class="item-meta">
                                <span class="item-date">{{ item.date }}</span>
                                <button class="edit-button" @click="editNotice(item.id)">수정 하기</button>
                            </div>
                        </div>
                        <button class="arrow-button" @click="editNotice(item.id)">
                            <span class="arrow-icon">›</span>
                        </button>
                    </li>
                </ul>
            </base-card>
            <base-card class="grid-1-card">
                <div class="card-header">
                    <h2 class="card-title">이용가이드</h2>
                    <button class="add-button" @click="goToPage('guide')">+</button>
                </div>
                <div class="divider"></div>
                <ul class="card-items">
                    <li v-for="item in guide" :key="item.id" class="tab-item">
                        <div class="tab-base">
                            <p class="item-title">{{ item.title }}</p>
                            <div class="item-meta">
                                <span class="item-date">{{ item.date }}</span>
                                <button class="edit-button" @click="editGuide(item.id)">수정 하기</button>
                            </div>
                        </div>
                        <button class="arrow-button" @click="editGuide(item.id)">
                            <span class="arrow-icon">›</span>
                        </button>
                    </li>
                </ul>
            </base-card>
        </div>

        <!-- Grid 2: 개인정보처리방침, 이용약관 (1x2) -->
        <div class="grid-2">
            <base-card class="grid-2-card">
                <div class="policy-header">
                    <h2 class="policy-title">개인 정보 처리 방침</h2>
                    <button class="arrow-button" @click="editPolicy()">
                        <span class="arrow-icon">›</span>
                    </button>
                </div>
            </base-card>
            <base-card class="grid-2-card">
                <div class="policy-header">
                    <h2 class="policy-title">이용약관</h2>
                    <button class="arrow-button" @click="editTerms()">
                        <span class="arrow-icon">›</span>
                    </button>
                </div>
            </base-card>
        </div>
    </div>
</template>

<script>
import * as noticeApi from '@/api/notice'
import * as guideApi from '@/api/guide'
import { useRouter } from 'vue-router'
import { onMounted, reactive, toRef } from 'vue';
function getDate(str) {
    let date = new Date(str)
    let strr = `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`
    return strr
}
export default {
    setup() {
        onMounted(() => {
            getNotice()
            getGuide()
        })
        const router = useRouter()
        const state = reactive({
            notice: [],
            guide: []
        })
        const notice = toRef(state, 'notice')
        const guide = toRef(state, 'guide')
        const getNotice = () => {
            noticeApi.getNotice().then((res) => {
                let notices = res.data.response.notices
                notices.forEach((d) => {
                    state.notice.push({ title: d.title, date: getDate(d.createdAt), id: d.id })
                })
            })
        }
        const editNotice = (id) => {
            router.push({
                path: "/notice/edit",
                state: {
                    data: id
                }
            })
        }
        const editPolicy = () => {
            router.push({
                path: "/policy",
            })
        }
        const editTerms = () => {
            router.push({
                path: "/terms",
            })
        }
        const getGuide = () => {
            guideApi.getGuide().then((res) => {
                let guide = res.data.response.guides
                guide.forEach((d) => {
                    state.guide.push({ title: d.title, date: getDate(d.createdAt), id: d.id })
                })
            })
        }
        const editGuide = (id) => {
            router.push({
                path: "/guide/edit",
                state: {
                    data: id
                }
            })
        }
        const goToPage = (target) => {
            if (router.currentRoute.path !== target) {
                router.push(target);
            }
        }
        return {
            state, notice, guide, getNotice, editNotice, getGuide, editGuide, editPolicy, editTerms, goToPage,
        }
    }
};
</script>

<style scoped>
/* Dashboard container */
.dashboard-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 28px;
    padding: 40px 20px;
}

/* Grid 1: 공지사항, 이용가이드 (1x2) */
.grid-1 {
    display: flex;
    flex-direction: row;
    gap: 16px;
    width: 100%;
    max-width: 1436px;
}

.grid-1-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 20px 0px 32px !important;
    gap: 16px;
    width: 701px;
}

/* Card header */
.card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px 24px;
    width: 701px;
    height: 34px;
}

.card-title {
    margin: 0;
    font-family: 'Pretendard', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 34px;
    letter-spacing: -0.3px;
    color: #FFFFFF;
}

.add-button {
    width: 24px;
    height: 24px;
    background: transparent;
    border: none;
    color: #ECEFF1;
    font-size: 24px;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Divider */
.divider {
    width: 701px;
    height: 0px;
    border: 1px solid #90A4AE;
}

/* Card items list */
.card-items {
    list-style-type: none;
    padding: 0;
    margin: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0;
}

/* Tab item */
.tab-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 24px;
    gap: 20px;
    width: 701px;
    height: 48px;
}

.tab-base {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 8px;
    flex-grow: 1;
    height: 48px;
}

.item-title {
    margin: 0;
    font-family: 'Pretendard', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.3px;
    color: #ECEFF1;
}

.item-meta {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0px;
    gap: 8px;
    width: 100%;
    height: 18px;
}

.item-date {
    font-family: 'Pretendard', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.3px;
    color: #ECEFF1;
}

.edit-button {
    background: transparent;
    border: none;
    font-family: 'Pretendard', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: -0.3px;
    text-decoration-line: underline;
    color: #ECEFF1;
    cursor: pointer;
    padding: 0;
}

.arrow-button {
    width: 24px;
    height: 24px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.arrow-icon {
    font-size: 20px;
    color: #B0BEC5;
    line-height: 24px;
}

/* Grid 2: 개인정보처리방침, 이용약관 (1x2) */
.grid-2 {
    display: flex;
    flex-direction: row;
    gap: 16px;
    width: 100%;
    max-width: 1436px;
}

.grid-2-card {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 32px 24px !important;
    gap: 16px;
    width: 701px;
    height: 98px;
}

.policy-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.policy-title {
    margin: 0;
    width: auto;
    height: 34px;
    font-family: 'Pretendard', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 34px;
    letter-spacing: -0.3px;
    color: #FFFFFF;
}

.policy-header .arrow-icon {
    color: #ECEFF1;
}

/* Responsive design */
@media (max-width: 1460px) {
    .grid-1,
    .grid-2 {
        flex-direction: column;
        align-items: center;
    }
}

@media (max-width: 768px) {
    .grid-1-card,
    .grid-2-card,
    .card-header,
    .divider,
    .tab-item {
        width: 100%;
        max-width: 701px;
    }
}
</style>